import SalesService from "../SalesService";
import i18n from "../../../shared/i18n";
import IncrementsService from "../view/increments/IncrementsService";
import {
  SOURCE_SALES_DASHBOARD,
  SOURCE_SALES_TABLE,
  SOURCE_SALES_VIEW,
  SOURCE_SALE_TERM_VIEW,
  SOURCE_TIMED_AUCTION_SETTINGS,
  SALES_TABLE_NAME,
  SOURCE_RESERVATION_SALE_SETTINGS
} from "../../constants";
import SaleSearch from "../SaleSearch.model";
import {store} from "@/plugins/vuex";
import helperService from "@/core/services/helper.service";
import cloneDeep from "lodash/cloneDeep";
import batchLotUpV2 from './../batch-lot-up-v2/vuex';

let getDefaultTableData = (differentFields = []) => {
  return {
    loading: false,
    rows: [],
    pagination: {
      limit: 50,
      page: 1,
      total: 0,
    },
    ordering: '-start_date',
    search: '',
    searchModel: new SaleSearch(),
    expand: 'department,total_items,currency',
    toggleColumns: {
      fields: [...getDefaultFields(), ...differentFields],
      requiredFields: ['sale_no', 'live_reference'],
      defaultFields: ['sale_no', 'status', 'start_date', 'title', 'department', 'currency', 'items', 'type', 'live_reference', 'hammer_target'],
      dynamicFields: [],
    }
  }
};

let getDefaultTableDataForLLP = () => {
  return {
    loading: false,
    rows: [],
    pagination: {
      limit: 50,
      page: 1,
      total: 0,
    },
    ordering: '-end_date',
    search: '',
    searchModel: new SaleSearch(),
    expand: 'department,currency',
    toggleColumns: {
      fields: [...getDefaultFieldsForLLP()],
      requiredFields: ['sale_no', 'title', 'start_date', 'end_date', 'llp'],
      defaultFields: [
        "uuid",
        "sale_no",
        "title",
        "start_date",
        "end_date",
        "currency_uuid",
        "created_at",
        "updated_at",
        "department",
        "currency",
        'total_bidders',
        'approved_bidders',
        'pending_bidders',
        'rejected_bidders',
        'deposit_require_pending_bidders',
        'total_lots',
        'sold_lots',
        'unsold_lots',
        // 'total_count_over_reserve',
        'total_amount_over_reserve',
        // 'total_count_bellow_reserve',
        'total_amount_bellow_reserve',
      ],
      dynamicFields: [],
    }
  }
}

let getDefaultFields = () => {
  return [
    {key: 'sale_no', label: i18n.t('Sale'), sortable: true, tdClass: 'col-saleno', isVisible: true, expand: ''},
    {key: 'status', label: i18n.t('Status'), sortable: true, tdClass: 'status-col', isVisible: true, expand: ''},
    {
      key: 'start_date',
      label: i18n.t('Start - End Date'),
      sortable: true,
      tdClass: 'start-date-col',
      isVisible: true,
      expand: 'dates'
    },
    {key: 'title', label: i18n.t('Title'), sortable: true, tdClass: 'title-col', isVisible: true, expand: ''},
    {
      key: 'department',
      label: i18n.t('Department'),
      sortable: true,
      tdClass: 'department-col',
      isVisible: true,
      expand: 'department'
    },
    {
      key: 'currency',
      label: i18n.t('Currency'),
      sortable: true,
      tdClass: 'currency-col',
      isVisible: true,
      expand: 'currency'
    },
    {
      key: 'items',
      label: i18n.t('Items'),
      sortable: true,
      tdClass: 'items-col',
      isVisible: true,
      expand: 'total_items'
    },
    {key: 'type', label: i18n.t('Auction Type'), sortable: true, tdClass: 'type-col', isVisible: true, expand: ''},
    {
      key: 'live_reference',
      label: i18n.t('Live Auctions ref.'),
      sortable: true,
      tdClass: 'live-reference-col',
      isVisible: true,
      expand: ''
    },
    {
      key: 'premiums',
      label: i18n.t('Premiums'),
      sortable: false,
      tdClass: 'premiums-col',
      isVisible: false,
      expand: 'premiums',
      exclude_from_export: true
    },
    {
      key: 'payment_terms',
      label: i18n.t('Payment Terms'),
      sortable: true,
      tdClass: 'payment-terms-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'settlement_days',
      label: i18n.t('Settlement Days'),
      sortable: true,
      tdClass: 'settlement-days-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'reserved_items',
      label: i18n.t('Reserved Items'),
      sortable: true,
      tdClass: 'reserved-items-col',
      isVisible: false,
      expand: 'reserved_items'
    },
    {
      key: 'total_lots',
      label: i18n.t('Lots'),
      sortable: true,
      tdClass: 'total-lots-col',
      isVisible: false,
      expand: 'total_lots'
    },
    {
      key: 'estimate',
      label: i18n.t('Estimate'),
      sortable: false,
      tdClass: 'estimate-col',
      isVisible: false,
      expand: 'low_estimate_amount,high_estimate_amount'
    },
    {
      key: 'reserve',
      label: i18n.t('Reserve'),
      sortable: true,
      tdClass: 'reserve-col',
      isVisible: false,
      expand: 'reserve_amount'
    },
    {
      key: 'sold_lots',
      label: i18n.t('Sold Lots'),
      sortable: true,
      tdClass: 'sold-lots-col',
      isVisible: false,
      expand: 'sold_lots'
    },
    {
      key: 'unsold_lots',
      label: i18n.t('Unsold Lots'),
      sortable: true,
      tdClass: 'unsold-lots-col',
      isVisible: false,
      expand: 'unsold_lots'
    },
    {
      key: 'created_data',
      label: i18n.t('Created at / Created by'),
      sortable: false,
      tdClass: 'created-data-col',
      isVisible: false,
      expand: 'created_by'
    },
    {
      key: 'updated_data',
      label: i18n.t('Updated at / Updated by'),
      sortable: false,
      tdClass: 'updated-data-col',
      isVisible: false,
      expand: 'updated_by'
    },
    {
      key: 'after_sale_end_date',
      label: i18n.t('After Sale End Date'),
      sortable: true,
      tdClass: 'after-sale-end-date-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'require_credit_card_verification',
      label: i18n.t('Require Credit Card Verification'),
      sortable: true,
      tdClass: 'require-credit-card-verification-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'require_identity_verification',
      label: i18n.t('Require Identity Verification'),
      sortable: true,
      tdClass: 'require-identity-verification-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'hammer_target',
      label: i18n.t('Hammer Target'),
      sortable: true,
      tdClass: 'hammer-target-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'account_managers',
      label: i18n.t('Account Managers'),
      sortable: false,
      tdClass: 'account_managers-col',
      isVisible: true,
      expand: 'account_managers'
    },
    {
      key: 'is_private',
      label: i18n.t('Private Sale'),
      sortable: true,
      tdClass: 'is-private-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'auctioneers_sheet',
      label: i18n.t("Auctioneer's Sheet"),
      sortable: false,
      isVisible: false,
      expand: ''
    },
    {
      key: 'after_sale_auctioneers_sheet',
      label: i18n.t("After Sale Auctioneer's Sheet"),
      sortable: false,
      isVisible: false,
      expand: ''
    },
    {
      key: 'buyer_group_account',
      label: i18n.t('Buyer Group Account'),
      sortable: false,
      isVisible: false,
      expand: ''
    },
    {
      key: 'vendor_group_account',
      label: i18n.t('Vendor Group Account'),
      sortable: false,
      isVisible: false,
      expand: ''
    },
  ]
}

let getDefaultFieldsForLLP = () => {
  return [
    {key: 'sale_no', label: i18n.t('Sale'), sortable: true, tdClass: 'col-saleno', isVisible: true, expand: ''},
    // {
    //   key: 'images',
    //   label: i18n.t('Images'),
    //   isVisible: true,
    // },
    {key: 'title', label: i18n.t('Title'), sortable: true, tdClass: 'title-col', isVisible: true, expand: ''},
    {
      key: 'start_date',
      label: i18n.t('Start Date'),
      sortable: true,
      tdClass: 'start-date-col',
      isVisible: true,
      expand: 'dates'
    },
    {
      key: 'end_date',
      label: i18n.t('End Date'),
      sortable: true,
      tdClass: 'end-date-col',
      isVisible: true,
      expand: 'dates'
    },
    {
      key: 'total_bidders',
      label: i18n.t('No. of Bidders'),
      sortable: false,
      tdClass: 'total_bidders-col',
      isVisible: true
    },
    {
      key: 'approved_bidders',
      label: i18n.t('Approved Bidders'),
      sortable: false,
      tdClass: 'approved_bidders-col',
      isVisible: true
    },
    {
      key: 'pending_bidders',
      label: i18n.t('Pending Bidders'),
      sortable: false,
      tdClass: 'pending_bidders-col',
      isVisible: true
    },
    {
      key: 'rejected_bidders',
      label: i18n.t('Rejected Bidders'),
      sortable: false,
      tdClass: 'rejected_bidders-col',
      isVisible: true
    },
    // {
    //   key: 'deposit_require_pending_bidders',
    //   label: i18n.t('Awaiting Deposit Bidders'),
    //   sortable: false,
    //   tdClass: 'deposit_require_pending_bidders-col',
    //   isVisible: true
    // },
    {
      key: 'total_lots',
      label: i18n.t('Number of Lots'),
      sortable: false,
      tdClass: 'total_lots-col',
      isVisible: true
    },
    {
      key: 'sold_lots',
      label: i18n.t('Total Sold'),
      sortable: false,
      tdClass: 'sold_lots-col',
      isVisible: true
    },
    {
      key: 'unsold_lots',
      label: i18n.t('Total Unsold'),
      sortable: false,
      tdClass: 'unsold_lots-col',
      isVisible: true
    },
    // {
    //   key: 'total_count_over_reserve',
    //   label: i18n.t('Total Over Reserve'),
    //   sortable: false,
    //   tdClass: 'total_count_over_reserve-col',
    //   isVisible: true
    // },
    // {
    //   key: 'total_count_bellow_reserve',
    //   label: i18n.t('Total Under Reserve'),
    //   sortable: false,
    //   tdClass: 'total_count_bellow_reserve-col',
    //   isVisible: true
    // },
    {
      key: 'total_amount_over_reserve',
      label: i18n.t('Total Over Reserve'),
      sortable: false,
      tdClass: 'total_amount_over_reserve-col',
      isVisible: true
    },
    {
      key: 'total_amount_bellow_reserve',
      label: i18n.t('Total Under Reserve'),
      sortable: false,
      tdClass: 'total_amount_bellow_reserve-col',
      isVisible: true
    },
    // {
    //   key: 'llp',
    //   label: i18n.t('LLP'),
    //   sortable: false,
    // },
  ]
}

export default {
  namespaced: true,
  state: {
    statuses: [
      {value: 'draft', key: i18n.t('Draft'),},
      {value: 'published', key: i18n.t('Published'),},
      {value: 'completed', key: i18n.t('Completed'),},
    ],
    auctionTypes: [
      {key: 'live', text: i18n.t('Live'),},
      {key: 'timed', text: i18n.t('Timed'),}
    ],
    viewByAppointmentOptions: [
      {key: 'no', text: i18n.t("No")},
      {key: 'yes', text: i18n.t("Yes")},
      {key: 'yes_with_dates', text: i18n.t("Yes with dates")}
    ],
    modal: {
      show: false,
      object: null,
      source: null
    },
    saleResumeModal: {
      show: false,
    },
    salePauseModal: {
      show: false,
    },
    tableSource: null,
    tableData: {
      sale: getDefaultTableData(),
      llp: getDefaultTableDataForLLP()
    },
    batchLotUpData: {
      sale: null,
      items: null,
      reservedLotNos: [],
      loading: false,
      lotNosWithLiveId: [],
    },
    view: {
      images: [],
      dashboardData: {
        projectionInfo: {
          data: {
            premium_amount: 0,
            commission_amount: 0,
            misc_charges_amount: 0,
          },
          loader: false
        },
        generalInfo: {
          data: {
            invoice_amount: {},
            paid_invoice_amount: {},
            outstanding_invoice_amount: {},
            invoices: 0,
            settlement_amount: {},
            paid_settlement_amount: {},
            outstanding_settlement_amount: {},
            settlements: 0,
            unsettled_sold_lots: 0,
            uninvoiced_sold_lots: 0,
            collected_lots: 0,
            uncollected_lots: 0,
          },
          loader: false
        },
        profileInfo: {
          data: {
            sold_lots: 0,
            unsold_lots: 0,
            lots: 0,
            vendors: 0,
            buyers: 0,
            bidders: 0,
            commission_bidders: 0,
            sold_low_estimate_amount: 0,
            sold_high_estimate_amount: 0,
            hammer_price_amount: 0,
            low_estimate_amount: 0,
            high_estimate_amount: 0,
            reserve_amount: 0,
            reserved_items: 0,
            highest_bids: 0
          },
          loader: false
        },
        itemsByCategory: {
          data: [],
          loader: false
        },
        collections: {
          data: [],
          loading: false
        },
        totalVat: {
          loader: false,
          data: [],
        },
      },
      loading: false,
      currentSale: null,
      incrementData: {
        loading: false,
        increments: [],
        modal: {
          show: false,
          objects: null,
          source: null,
          auction_uuid: null,
        }
      },
      incrementCalculationData: {
        loading: false,
        modal: {
          show: false,
          object: null,
          source: null
        }
      },
      auctionCategoryTermsData: {
        loading: false,
        auctionCategoryTerms: [],
        modal: {
          show: false,
          object: null,
          source: null,
          auction: null,
        }
      },
      termsData: {
        showPremiumsModal: false,
        premiums: [],
        minimum_premium: 0,
        loading: false,
        payment_terms: null,
        settlement_days: null,
        currency_exchanges: null,
        premiumsModal: {
          show: false,
          source: null
        },
        settlementDaysModal: {
          show: false,
          source: null
        },
        currencyExchangesModal: {
          show: false,
          currencyExchanges: {},
          source: null
        },
        paymentTermsModal: {
          show: false,
          source: null
        }
      },
      auctionSettingsData: {
        loading: false,
        data: {},
        modal: {
          show: false,
          object: null,
          source: null,
          auction_uuid: null,
        }
      },
    },
    saleSyncProgresses: {},
    saleSyncProcessIdToProgressMap: {},
    collectionModal: {
      show: false,
      object: null,
      source: null,
      sale: null,
    },
    saleExportModal: {
      sale: null,
      show: false,
      fileType: null
    }
  },
  getters: {
    toggleColumns: state => {
      const data = state.tableData[state.tableSource].toggleColumns
      data.tableName = `${SALES_TABLE_NAME}.${state.tableSource}`
      return data
    },
    tableFields: (state, getters) => {
      return getters.toggleColumns.fields.filter(f => f.isVisible)
    }
  },
  actions: {
    initTableData({state}) {
      state.tableData.sale = getDefaultTableData();
      state.tableData.llp = getDefaultTableDataForLLP();
      return true
    },
    showModal({commit}, {object = null, source} = {}) {
      commit('showModal', {object: cloneDeep(object), source});
    },
    hideModal({commit}) {
      commit('hideModal');
    },
    showSaleResumeModal({commit}) {
      commit('showSaleResumeModal');
    },
    hideSaleResumeModal({commit}) {
      commit('hideSaleResumeModal');
    },
    showSalePauseModal({commit}) {
      commit('showSalePauseModal');
    },
    hideSalePauseModal({commit}) {
      commit('hideSalePauseModal');
    },
    resetTableDataPaginationPage({state}) {
      state.tableData[state.tableSource].pagination.page = 1;
    },
    updateSearchModel({commit, state}, searchModel) {
      commit('updateSearchModel', new SaleSearch({
        ...state.tableData[state.tableSource].searchModel,
        ...searchModel
      }));
    },
    async getTableParams({state}, payload = null) {
      let data;
      const ordering = await store.dispatch('global/getTableDataOrdering', {
        tableData: state.tableData[state.tableSource],
        tableName: `${SALES_TABLE_NAME}.${state.tableSource}`
      });

      if (payload) {
        data = {
          ...payload.pagination,
          search: payload.search,
          ordering: payload.ordering,
        };
      } else {
        data = {
          ...state.tableData[state.tableSource].pagination,
          search: state.tableData[state.tableSource].search,
          ordering: ordering
        }
      }

      if (state.tableData[state.tableSource].searchModel) {
        const searchModelData = state.tableData[state.tableSource].searchModel.toJSON();
        data = {
          ...data,
          ...searchModelData
        }
      }

      const defaultExpand = state.tableData[state.tableSource].expand
      const expand = state.tableData[state.tableSource].toggleColumns.fields
        .filter(c => state.tableData[state.tableSource].toggleColumns.defaultFields.includes(c.key) && c.expand && !defaultExpand.includes(c.expand))
        .map(c => c.expand)
        .join(',')

      data.expand = `${expand},${defaultExpand}`;

      return data;
    },
    async getTableData({commit, state, dispatch, rootState}, payload) {
      const withLoader = !(payload ? payload.withoutLoader : false);
      if (payload) {
        delete payload.withoutLoader;
        if (!Object.keys(payload).length) {
          payload = null;
        }
      }

      let params = await dispatch('getTableParams', payload);

      if (withLoader) {
        commit('updateTableLoading', true);
      }
      let response = null;
      if (state.tableSource === 'llp') {
        response = await SalesService.getSalesForLLP(params);
      } else {
        response = await SalesService.getSales(params);
      }
      if (withLoader) {
        commit('updateTableLoading', false);
      }

      if (response.success) {

        if (rootState.global.enableTimedSessions) {
          for (let i in response.body.results) {
            let tmpSale = response.body.results[i]
            if (tmpSale.type === 'timed' && tmpSale.dates && tmpSale.dates.length > 1) {
              response.body.results[i].dates = helperService.orderDatesByKey(tmpSale.dates, 'end_date')
            }
          }
        }

        commit('updateTableData', {
          rows: response.body.results,
          pagination: {limit: params.limit, page: params.page, total: response.body.count},
          ordering: params.ordering,
          search: params.search
        });
      }

      return response;
    },
    async resetTable({state, dispatch}) {
      const tmpToggleColumns = cloneDeep(state.tableData[state.tableSource].toggleColumns);
      let defaultTableData = getDefaultTableData();
      defaultTableData.pagination.limit = state.tableData[state.tableSource].pagination.limit;
      state.tableData[state.tableSource] = defaultTableData;
      state.tableData[state.tableSource].toggleColumns = tmpToggleColumns;
      dispatch('getTableData');
    },
    async updateTableSource({state}, {extraFilters, source}) {
      state.tableSource = source;
      state.tableData[source].extraFilters = extraFilters;
    },
    createSale({commit}, sale) {
      return SalesService.createSale(sale);
    },
    async updateSale({commit, dispatch, state}, sale) {
      let response = await SalesService.updateSale(sale.uuid, sale, 'branch,department,catalogs,currency,clerks,available_post_actions,account_managers');
      if (response.success) {
        if (state.modal.source === SOURCE_SALES_TABLE) {
          commit('updateSale', response.body);
        } else if (state.view.auctionSettingsData.modal.source === SOURCE_RESERVATION_SALE_SETTINGS) {
          dispatch('reservations/updateSale', response.body, {root: true});
        } else if (state.modal.source === SOURCE_SALES_DASHBOARD
          || state.modal.source === SOURCE_SALES_VIEW
          || state.view.auctionSettingsData.modal.source === SOURCE_TIMED_AUCTION_SETTINGS) {
          commit('updateViewSale', response.body);
        }
      }
      return response;
    },
    async updateSaleSettings({commit, dispatch, state}, payload) {
      let response = await SalesService.partialUpdateSale(
        state.view.auctionSettingsData.modal.auction_uuid,
        payload,
        'branch,department,catalogs,currency,clerks,available_post_actions'
      );
      if (response.success) {
        if (state.view.auctionSettingsData.modal.source === SOURCE_RESERVATION_SALE_SETTINGS) {
          dispatch('reservations/updateSale', response.body, {root: true});
        } else if (state.view.auctionSettingsData.modal.source === SOURCE_TIMED_AUCTION_SETTINGS) {
          commit('updateViewSale', response.body);
        }
      }
      return response;
    },
    async getSale({commit, rootState}, uuid) {
      commit('changeCurrentSaleLoading');
      let {
        success,
        body
      } = await SalesService.getSale(uuid, 'auction_images_export.created_by,branch,department,dates,currency,catalogs,clerks.languages,available_post_actions,auction_collections,website_url');
      commit('changeCurrentSaleLoading');
      if (success) {

        if (rootState.global.enableTimedSessions) {
          if (body.type === 'timed' && body.dates && body.dates.length > 1) {
            body.dates = helperService.orderDatesByKey(body.dates, 'end_date')
          }
        }

        commit('updateViewSale', body);
      }
      return success;
    },
    async removeSale({dispatch, state}, sale) {
      let response = await SalesService.removeSale(sale.uuid);
      if (response.success) {
        dispatch('getTableData', {
          ...state.tableData[state.tableSource],
          search: state.tableData[state.tableSource].search,
          ordering: state.tableData[state.tableSource].ordering
        })
      }
      return response;
    },
    async updateViewSale({commit}, sale) {
      commit('updateViewSale', sale);
    },
    showIncrementModal({commit}, {objects = [], source, auction_uuid} = {}) {
      commit('showIncrementModal', {objects: cloneDeep(objects), source, auction_uuid});
    },
    showIncrementCalculationModal({commit}, {object = [], source} = {}) {
      commit('showIncrementCalculationModal', {object: cloneDeep(object), source});
    },
    showAuctionSettingsModal({commit}, {object = [], source, auction_uuid} = {}) {
      commit('showAuctionSettingsModal', {object: cloneDeep(object), source, auction_uuid});
    },
    hideIncrementModal({commit}) {
      commit('hideIncrementModal');
    },
    hideIncrementCalculationModal({commit}) {
      commit('hideIncrementCalculationModal');
    },
    hideAuctionSettingsModal({commit}) {
      commit('hideAuctionSettingsModal');
    },
    async postIncrements({commit, state}, payload) {
      let response = await IncrementsService.postIncrements(state.view.incrementData.modal.auction_uuid, payload);
      if (response.success) {
        commit('updateIncrementsTableIncrements', response.body);
      }
      return response;
    },
    async getIncrements({commit}, auction_uuid) {
      commit('updateIncrementsTableLoading', true);
      let response = await IncrementsService.getIncrements(auction_uuid);
      commit('updateIncrementsTableLoading', false);
      if (response.success) {
        commit('updateIncrementsTableIncrements', response.body);
      }
      return response;
    },
    async getTermsData({commit, state}) {
      commit('toggleTermsLoader', true);
      let response = await SalesService.getSale(state.view.currentSale.uuid, 'premiums');
      commit('toggleTermsLoader', false);

      if (response.success) {
        let {premiums} = response.body;
        await commit('updateTermsData', {
          premiums,
          minimum_premium: response.body.minimum_premium,
          payment_terms: response.body.payment_terms,
          settlement_days: response.body.settlement_days,
          currency_exchanges: response.body.currency_exchanges,
        });

      }

      return response
    },
    async togglePremiumsModal({commit}, payload) {
      commit('togglePremiumsModal', payload);
    },
    async togglePaymentTermsModal({commit}, payload) {
      commit('togglePaymentTermsModal', payload);
    },
    async toggleSettlementDaysModal({commit}, payload, source) {
      commit('toggleSettlementDaysModal', payload, source);
    },
    async saveTermsPartialData({commit, state}, payload) {
      let response = await SalesService.partialUpdateSale(state.view.currentSale.uuid, payload);
      if (response.success) {
        commit('updateTermsData', payload);
        if (state.view.termsData.paymentTermsModal.source === SOURCE_SALE_TERM_VIEW
          || state.view.termsData.settlementDaysModal.source === SOURCE_SALE_TERM_VIEW
          || state.view.incrementCalculationData.modal.source === SOURCE_SALE_TERM_VIEW
          || state.view.termsData.premiumsModal.source === SOURCE_SALE_TERM_VIEW) {
          commit('updateCurrentSaleData', payload);
        }
      }
      return response;
    },
    async getDashboardData({dispatch}, payload) {
      dispatch('getDashboardProfileInfo', payload);
      dispatch('getDashboardProjectionInfo', payload);
      dispatch('getDashboardGeneralInfo', payload);
      dispatch('getDashboardItemsByCategory', payload);
      dispatch('getDashboardCollections', payload);
      dispatch('getTotalVat', payload);
    },
    async getDashboardProfileInfo({state}, payload) {
      state.view.dashboardData.profileInfo.loader = true;
      let response = await SalesService.getDashboardProfileInfo(payload);
      if (response.success) {
        state.view.dashboardData.profileInfo.data = {
          ...state.view.dashboardData.profileInfo.data,
          ...response.body
        };
      }
      state.view.dashboardData.profileInfo.loader = false
    },
    async getDashboardGeneralInfo({state}, payload) {
      state.view.dashboardData.generalInfo.loader = true;
      let response = await SalesService.getDashboardGeneralInfo(payload);
      if (response.success) {
        state.view.dashboardData.generalInfo.data = {
          ...state.view.dashboardData.generalInfo.data,
          ...response.body
        };
      }
      state.view.dashboardData.generalInfo.loader = false
    },
    async getDashboardProjectionInfo({state}, payload) {
      state.view.dashboardData.projectionInfo.loader = true;
      let response = await SalesService.getDashboardProjectionInfo(payload);
      if (response.success) {
        state.view.dashboardData.projectionInfo.data = {
          ...state.view.dashboardData.projectionInfo.data,
          ...response.body
        };
      }
      state.view.dashboardData.projectionInfo.loader = false
    },
    async getDashboardItemsByCategory({state}, payload) {
      state.view.dashboardData.itemsByCategory.loader = true;
      state.view.dashboardData.itemsByCategory.data = await SalesService.getDashboardItemsByCategory(payload);
      state.view.dashboardData.itemsByCategory.loader = false
    },
    async getDashboardCollections({state}, payload) {
      state.view.dashboardData.collections.loader = true;
      let response = await SalesService.getSaleCollections(payload);
      if (response.success) {
        state.view.dashboardData.collections.data = response.body.results
      }
      state.view.dashboardData.collections.loader = false
    },
    async getTotalVat({state}, payload) {
      state.view.dashboardData.totalVat.loader = true;
      let response = await SalesService.getDashboardTotalVat(payload);
      if (response.success) {
        state.view.dashboardData.totalVat.data = response.body
      }
      state.view.dashboardData.totalVat.loader = false
    },
    async initBatchLotUpData({state, dispatch, commit}, saleNo) {
      commit('updateBatchLotUpLoading', true);

      let response = await SalesService.saleExists(saleNo, 'currency');
      if (response.success) {
        state.batchLotUpData.sale = response.body;
        await dispatch('getBatchLotUpData', state.batchLotUpData.sale.uuid);
      }

      commit('updateBatchLotUpLoading', false);
      return response;
    },
    async getBatchLotUpData({commit}, auctionUuid) {
      let response = await SalesService.getBatchLotUpData(auctionUuid);
      if (response.success) {
        commit('updateBatchLotUpData', response.body.results)
      }
      return response;
    },
    async getImages({commit}, uuid) {
      let response = await SalesService.getImages(uuid);

      if (response.success) {
        commit('updateImages', response.body);
      }

      return response;
    },
    async updateImages({commit}, payload) {
      await commit('updateImages', payload);
    },
    async syncToLive({dispatch}, payload) {
      return await SalesService.syncToLive(payload.sale_no, payload.action, payload.provider_name);
    },
    async exportAuctionProviderData({dispatch}, payload) {
      return await SalesService.exportAuctionProviderData(payload.sale_no, payload.action, payload.provider_name);
    },
    async updateStatus({dispatch}, payload) {
      return await SalesService.updateStatus(payload.status, payload.params);
    },
    async pauseResumeAction({commit, state}, {uuid, is_paused, resume_date, pause_message}) {
      const response = await SalesService.pauseResumeAction(uuid, {is_paused, resume_date, pause_message});
      if (response && response.success) {
        commit('updateViewSale', {...state.view.currentSale, ...response.body});
      }
      return response;
    },
    async getModalObject({commit}, {uuid, source}) {
      let response = await SalesService.getSale(uuid, 'branch,department,dates,currency,account_managers,catalogs')

      if (response.success) {
        commit('updateModalObject', {object: cloneDeep(response.body), source})
      }
    },
    async updateToggleColumns({commit, dispatch}, payload) {
      if (payload.isSaveAction) {
        commit('updateTableLoading', true);
        await commit('updateToggleColumns', payload.selectedColumns);
        await dispatch('getTableData');
        commit('updateTableLoading', false);
      } else {
        await commit('updateToggleColumns', payload.selectedColumns);
      }
    },
    async toggleCurrencyExchangesModal({commit}, payload) {
      commit('toggleCurrencyExchangesModal', payload);
    },
    showCollectionModal({commit}, {object = null, source, sale = {}} = {}) {
      commit('showCollectionModal', {object: cloneDeep(object), source, sale});
    },
    hideCollectionModal({commit}) {
      commit('hideCollectionModal');
    },
    async createSaleCollection({state}, payload) {
      let response = await SalesService.createSaleCollections(payload);
      if (response.success) {
        if (state.collectionModal.source === SOURCE_SALES_DASHBOARD) {
          state.view.dashboardData.collections.data.unshift(response.body)
          if (!state.view.currentSale.auction_collections) {
            state.view.currentSale.auction_collections = []
          }
          state.view.currentSale.auction_collections.unshift(response.body)
        }
      }
      return response
    },
    async updateSaleCollection({state}, payload) {
      let response = await SalesService.updateSaleCollections(payload.uuid, payload);
      if (response.success) {
        if (state.collectionModal.source === SOURCE_SALES_DASHBOARD) {
          let index = state.view.dashboardData.collections.data.findIndex(i => i.uuid === payload.uuid)
          state.view.dashboardData.collections.data[index] = {
            ...state.view.dashboardData.collections.data[index], ...response.body
          }
          state.view.dashboardData.collections.data = [...state.view.dashboardData.collections.data];
          index = state.view.currentSale.auction_collections.findIndex(i => i.uuid === payload.uuid)
          state.view.currentSale.auction_collections[index] = {
            ...state.view.currentSale.auction_collections[index], ...response.body
          }
          state.view.currentSale.auction_collections = [...state.view.currentSale.auction_collections];
        }
      }
      return response
    },
    async deleteSaleCollection({state}, payload) {
      let response = await SalesService.removeSaleCollection(payload.uuid)
      if (response.success) {
        let index = state.view.dashboardData.collections.data.findIndex(i => i.uuid === payload.uuid)
        if (index > -1) {
          state.view.dashboardData.collections.data.splice(index, 1);
        }
        index = state.view.currentSale.auction_collections.findIndex(i => i.uuid === payload.uuid)
        if (index > -1) {
          state.view.currentSale.auction_collections.splice(index, 1);
        }
      }
      return response
    },
    async showSaleExportModal({state}, {sale, fileType}) {
      state.saleExportModal.show = true
      state.saleExportModal.sale = cloneDeep(sale)
      state.saleExportModal.fileType = fileType
    },
    async hideSaleExportModal({state}) {
      state.saleExportModal.show = false
      state.saleExportModal.sale = null
      state.saleExportModal.fileType = null
    },
    updateCurrentSaleData({commit}, data) {
      commit('updateCurrentSaleData', cloneDeep(data))
    },
    showAuctionCategoryTermModal({commit}, {object = null, source, auction = {}} = {}) {
      commit('showAuctionCategoryTermModal', {object: cloneDeep(object), source, auction});
    },
    hideAuctionCategoryTermModal({commit}) {
      commit('hideAuctionCategoryTermModal');
    },
    async createAuctionCategoryTerm({state}, payload) {
      let response = await SalesService.createAuctionCategoryTerm(payload, 'category')
      if (response.success) {
        state.view.auctionCategoryTermsData.auctionCategoryTerms.unshift(response.body)
      }
      return response
    },
    async updateAuctionCategoryTerm({state}, payload) {
      let response = await SalesService.updateAuctionCategoryTerm(payload.uuid, payload, 'category')
      if (response.success) {
        let index = state.view.auctionCategoryTermsData.auctionCategoryTerms.findIndex(i => i.uuid === payload.uuid)
        state.view.auctionCategoryTermsData.auctionCategoryTerms[index] = response.body
        state.view.auctionCategoryTermsData.auctionCategoryTerms = [...state.view.auctionCategoryTermsData.auctionCategoryTerms]
      }
      return response
    },
    async getAuctionCategoryTerms({state}, auction_uuid) {
      state.view.auctionCategoryTermsData.loading = true;
      let response = await SalesService.getAuctionCategoryTerms({auction_uuid, limit: 200, expand: 'category'});
      state.view.auctionCategoryTermsData.loading = false;
      if (response.success) {
        state.view.auctionCategoryTermsData.auctionCategoryTerms = response.body.results
      }
      return response;
    },
    async deleteAuctionCategoryTerm({state}, payload) {
      let response = await SalesService.removeAuctionCategoryTerm(payload.uuid)
      if (response.success) {
        let index = state.view.auctionCategoryTermsData.auctionCategoryTerms.findIndex(i => i.uuid === payload.uuid)
        if (index > -1) {
          state.view.auctionCategoryTermsData.auctionCategoryTerms.splice(index, 1);
        }
      }
      return response
    }
  },
  mutations: {
    updateImages: (state, images) => state.view.images = images,
    showModal: (state, {object, source}) => {
      state.modal.show = true;
      state.modal.object = object;
      state.modal.source = source;
    },
    hideModal: state => state.modal.show = false,
    showSaleResumeModal: (state) => {
      state.saleResumeModal.show = true;
    },
    hideSaleResumeModal: state => state.saleResumeModal.show = false,
    showSalePauseModal: (state) => {
      state.salePauseModal.show = true;
    },
    hideSalePauseModal: state => state.salePauseModal.show = false,
    showCollectionModal: (state, {object, source, sale}) => {
      state.collectionModal.show = true;
      state.collectionModal.object = object;
      state.collectionModal.source = source;
      state.collectionModal.sale = cloneDeep(sale);
    },
    hideCollectionModal: state => {
      state.collectionModal.show = false;
      state.collectionModal.object = null;
      state.collectionModal.source = null;
      state.collectionModal.sale = null;
    },
    updateTableData: (state, payload) => {
      state.tableData[state.tableSource] = {...state.tableData[state.tableSource], ...payload}
    },
    updateSearchModel: (state, searchModel) => state.tableData[state.tableSource].searchModel = searchModel,
    updateTableLoading: (state, payload) => state.tableData[state.tableSource].loading = payload,
    updateSale: (state, sale) => {
      const index = state.tableData[state.tableSource].rows.findIndex(r => r.uuid === sale.uuid);
      state.tableData[state.tableSource].rows[index] = {...state.tableData[state.tableSource].rows[index], ...sale};
      state.tableData[state.tableSource].rows = [...state.tableData[state.tableSource].rows];
    },
    changeCurrentSaleLoading: state => state.view.loading = !state.view.loading,
    updateViewSale: (state, sale) => state.view.currentSale = sale,
    showIncrementModal: (state, {objects, source, auction_uuid}) => {
      state.view.incrementData.modal.show = true;
      state.view.incrementData.modal.objects = objects;
      state.view.incrementData.modal.source = source;
      state.view.incrementData.modal.auction_uuid = auction_uuid;
    },
    showIncrementCalculationModal: (state, {object, source}) => {
      state.view.incrementCalculationData.modal.show = true;
      state.view.incrementCalculationData.modal.object = object;
      state.view.incrementCalculationData.modal.source = source;
    },
    showAuctionSettingsModal: (state, {object, source, auction_uuid}) => {
      state.view.auctionSettingsData.modal.show = true;
      state.view.auctionSettingsData.modal.object = object;
      state.view.auctionSettingsData.modal.source = source;
      state.view.auctionSettingsData.modal.auction_uuid = auction_uuid;
    },
    hideIncrementModal: state => state.view.incrementData.modal.show = false,
    hideIncrementCalculationModal: state => state.view.incrementCalculationData.modal.show = false,
    hideAuctionSettingsModal: state => state.view.auctionSettingsData.modal.show = false,
    updateIncrementsTableLoading: (state, payload) => state.view.incrementData.loading = payload,
    updateIncrementsTableIncrements: (state, payload) => state.view.incrementData.increments = payload,
    togglePremiumsModal: (state, data) => {
      state.view.termsData.premiumsModal.show = data.showModal;
      state.view.termsData.premiumsModal.source = data.source;
    },
    togglePaymentTermsModal: (state, data) => {
      state.view.termsData.paymentTermsModal.show = data.showModal
      state.view.termsData.paymentTermsModal.source = data.source;
    },
    toggleSettlementDaysModal: (state, data) => {
      state.view.termsData.settlementDaysModal.show = data.showModal;
      state.view.termsData.settlementDaysModal.source = data.source;
    },
    toggleCurrencyExchangesModal: (state, data) => {
      state.view.termsData.currencyExchangesModal.show = data.showModal;
      state.view.termsData.currencyExchangesModal.source = data.source;
      state.view.termsData.currencyExchangesModal.currencyExchanges = data.currencyExchanges;
    },
    toggleTermsLoader: (state, data) => state.view.termsData.loading = data,
    updateTermsData: (state, data) => {
      state.view.termsData = {...state.view.termsData, ...data};
    },
    updateCurrentSaleData: (state, data) => {
      state.view.currentSale = {...state.view.currentSale, ...data};
    },
    updateBatchLotUpLoading: (state, payload) => state.batchLotUpData.loading = payload,
    updateBatchLotUpData: (state, payload) => {
      state.batchLotUpData.reservedLotNos = [];
      state.batchLotUpData.reservedLotNos = payload.filter(i => !['lotted', 'reserved'].includes(i.status)).map(i => parseInt(i.lot_no))
      state.batchLotUpData.items = payload.filter(i => ['lotted', 'reserved'].includes(i.status))
      state.batchLotUpData.lotNosWithLiveId = state.batchLotUpData.items.filter(i => i.lot && i.lot.live_id).map(l => parseInt(l.lot_no))
    },
    addSaleSyncProgress: (state, processArray) => {
      state.saleSyncProgresses = {};
      for (let process of processArray) {
        state.saleSyncProgresses[process.id] = process;
      }
      state.saleSyncProgresses = {
        ...state.saleSyncProgresses
      };
    },
    deleteSaleSyncProgress: (state, processId) => {
      delete state.saleSyncProgresses[processId];
      state.saleSyncProgresses = {...state.saleSyncProgresses};
    },
    addSaleSyncProcessId: (state, {processId, progress}) => {
      state.saleSyncProcessIdToProgressMap = {
        ...state.saleSyncProcessIdToProgressMap,
        [processId]: progress
      };
    },
    deleteSaleSyncProcessId: (state, processId) => {
      delete state.saleSyncProcessIdToProgressMap[processId];
      state.saleSyncProcessIdToProgressMap = {...state.saleSyncProcessIdToProgressMap};
    },
    updateModalObject: (state, {object, source}) => {
      state.modal.object = object;
      state.modal.source = source;
    },
    updateToggleColumns: (state, selectedColumns) => {
      state.tableData[state.tableSource].toggleColumns.defaultFields = [...selectedColumns];
      let selectedFields = [];
      let notSelectedFields = [];
      selectedColumns.forEach(s => {
        selectedFields.push({
          ...state.tableData[state.tableSource].toggleColumns.fields.find(f => f.key === s),
          isVisible: true
        });
      });
      state.tableData[state.tableSource].toggleColumns.fields.forEach(f => {
        if (!selectedColumns.includes(f.key)) {
          notSelectedFields.push({...f, isVisible: false});
        }
      });
      state.tableData[state.tableSource].toggleColumns.fields = [...selectedFields, ...notSelectedFields];
    },
    showAuctionCategoryTermModal: (state, {object, source, auction}) => {
      state.view.auctionCategoryTermsData.modal.show = true;
      state.view.auctionCategoryTermsData.modal.object = object;
      state.view.auctionCategoryTermsData.modal.source = source;
      state.view.auctionCategoryTermsData.modal.auction = auction;
    },
    hideAuctionCategoryTermModal: (state) => {
      state.view.auctionCategoryTermsData.modal.show = false;
      state.view.auctionCategoryTermsData.modal.object = null;
      state.view.auctionCategoryTermsData.modal.source = null;
      state.view.auctionCategoryTermsData.modal.auction = null;
    },
  },
  modules: {
    batchLotUpV2: batchLotUpV2
  }
}
